import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import Link from "ds/components/Link";
import Badge from "ds/components/Badge";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemNameCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemNameCell = ({ roleBinding }: ApiKeyRolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <Box align="center" fullWidth gap="large">
      {roleBinding.role.isSystem ? (
        <>
          <TextEllipsis tooltip={roleBinding.role.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="span" variant="p-body3">
                {roleBinding.role.name}
              </Typography>
            )}
          </TextEllipsis>

          <Badge type="strong" variant="blue" text="SYSTEM" />
        </>
      ) : (
        <Link size="small" variant="secondary" href={roleUrl}>
          {roleBinding.role.name}
        </Link>
      )}
    </Box>
  );
};

export default ApiKeyRolesListItemNameCell;
